import React from 'react';

function Pagination({ currentPage, totalPages, onPageChange }) {
  if (totalPages <= 1) return null;
  const pageWindow = 5;
  let start = Math.max(1, currentPage - Math.floor(pageWindow / 2));
  let end = Math.min(totalPages, start + pageWindow - 1);
  if (end - start < pageWindow - 1) start = Math.max(1, end - pageWindow + 1);

  return (
    <ul className="pagination pagination-circle pagination-gutter mb-0" style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
      <li className={`page-item${currentPage === 1 ? ' disabled' : ''}`}>
        <a
          className="page-link rounded-circle"
          href="#/"
          style={{ width: 40, height: 40, display: 'flex', alignItems: 'center', justifyContent: 'center' }}
          onClick={e => {
            e.preventDefault();
            if (currentPage > 1) onPageChange(currentPage - 1);
          }}
        >
          <i className='fa fa-angle-double-left' />
        </a>
      </li>
      {Array.from({ length: end - start + 1 }, (_, i) => start + i).map(i => (
        <li key={i} className={`page-item${currentPage === i ? ' active' : ''}`}>
          <a
            className="page-link rounded-circle"
            href="#/"
            style={{ width: 40, height: 40, display: 'flex', alignItems: 'center', justifyContent: 'center' }}
            onClick={e => {
              e.preventDefault();
              onPageChange(i);
            }}
          >
            {i}
          </a>
        </li>
      ))}
      <li className={`page-item${currentPage === totalPages ? ' disabled' : ''}`}>
        <a
          className="page-link rounded-circle"
          href="#/"
          style={{ width: 40, height: 40, display: 'flex', alignItems: 'center', justifyContent: 'center' }}
          onClick={e => {
            e.preventDefault();
            if (currentPage < totalPages) onPageChange(currentPage + 1);
          }}
        >
          <i className='fa fa-angle-double-right' />
        </a>
      </li>
    </ul>
  );
}

export default Pagination;
